import BaseCrudService from './BaseCrudService';

/**
 * Notes Service
 * Extends BaseCrudService with notes-specific functionality
 */
class NotesService extends BaseCrudService {
  constructor() {
    super('/api/notes');
  }

  /**
   * Get all notes for the current user
   * @returns {Promise<Array>} List of notes
   */
  getUserNotes() {
    return this.getAll();
  }

  /**
   * Get note by ID
   * @param {string} id - Note ID
   * @returns {Promise<Object>} Note details
   */
  getNoteById(id) {
    return this.getById(id);
  }

  /**
   * Create a new note
   * @param {Object} noteData - Note data
   * @returns {Promise<Object>} Created note
   */
  createNote(noteData) {
    return this.create(noteData);
  }

  /**
   * Update a note
   * @param {string} id - Note ID
   * @param {Object} noteData - Note data
   * @returns {Promise<Object>} Updated note
   */
  updateNote(id, noteData) {
    return this.update(id, noteData);
  }

  /**
   * Delete a note
   * @param {string} id - Note ID
   * @returns {Promise<Object>} Response message
   */
  deleteNote(id) {
    return this.delete(id);
  }

  /**
   * Toggle note completion status (for to-dos)
   * @param {string} id - Note ID
   * @returns {Promise<Object>} Updated note
   */
  toggleNoteCompletion(id) {
    return this.customRequest('put', `${id}/toggle-completion`);
  }

  /**
   * Toggle note pinned status
   * @param {string} id - Note ID
   * @returns {Promise<Object>} Updated note
   */
  toggleNotePinned(id) {
    return this.customRequest('put', `${id}/toggle-pinned`);
  }
}

export default new NotesService();
